import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("ranger:logout"));
      }
    }
    return Promise.reject(error);
  }
);

const friendly = (d) => {
  if (!d || typeof d.msg !== "string") return JSON.stringify(d);
  const raw = (d.loc || []).filter((x) => typeof x === "string" && x !== "body").join(" ").replace(/_/g, " ").replace(/\bid\b/g, "ID");
  const field = raw.charAt(0).toUpperCase() + raw.slice(1);
  if (d.msg.includes("15,22")) return `${field || "ID"} must be a 15–22 digit Discord ID.`;
  if (d.msg.includes("a-z0-9._")) return "Item shortnames must be lowercase Rust names like wood or rifle.ak.";
  if (d.msg.includes("\\w \\-")) return `${field || "Name"}: letters, digits, spaces and - only.`;
  return field ? `${field}: ${d.msg}` : d.msg;
};

export const rconChanged = () => window.dispatchEvent(new Event("ranger:rcon"));

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(friendly).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ROLE_LEVEL = { viewer: 1, moderator: 2, admin: 3, owner: 4 };

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString() : "—");
